import { FormattedNumber, useIntl } from 'react-intl'
import { format } from 'date-fns'

import type { ColumnDef } from '@gto/ui/data-table'
import { createColumns } from '@gto/ui/data-table'
import { TruncatedText } from '@gto/ui/truncated-text'

import type { RedemptionHistory } from '@/api/gen'
import { fluidColumn } from '@/components/table-columns'

export const useRedemptionHistoryTableCols = (): ColumnDef<RedemptionHistory>[] => {
  const { formatMessage } = useIntl()

  return createColumns<RedemptionHistory>([
    {
      accessorKey: 'date',
      header: formatMessage({ id: 'rewards.earnings.table.date' }),
      ...fluidColumn({ min: 120, align: 'center', headerAlign: 'center' }),
      cell: ({ row }) => format(new Date(row.original.date), 'MMMM dd, yyyy'),
    },
    {
      accessorKey: 'item_name',
      header: formatMessage({ id: 'rewards.earnings.table.item' }),
      ...fluidColumn({ min: 200, align: 'center', headerAlign: 'center' }),
      // Wrapped onto a second line under DataGridPro's auto row height. DS rows are a fixed
      // per-density height and its cells never wrap, so this truncates and `TruncatedText`
      // reveals the full name — only when it is actually clipped.
      cell: ({ row }) => <TruncatedText variant="body2">{row.original.item_name}</TruncatedText>,
    },
    {
      accessorKey: 'item_cost',
      header: formatMessage({ id: 'rewards.earnings.table.cost' }),
      ...fluidColumn({ min: 120, align: 'center', headerAlign: 'center' }),
      cell: ({ row }) => <FormattedNumber value={row.original.item_cost} />,
    },
  ])
}
